import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Cart from './pages/user/Cart';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Profile from './pages/user/Profile';
import History from './pages/user/History';
import ResetPassword from './pages/auth/ResetPassword';
import RePassword from './pages/user/ResetPassword';

function App() {

    return (
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <Routes>
                <Route path="/" element={<Cart />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/history" element={<History />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/re-password" element={<RePassword />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
